import { render } from "./setReporting.vue?vue&type=template&id=477b3d9d"
import script from "./setReporting.vue?vue&type=script&lang=js"
export * from "./setReporting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__